// extracted by mini-css-extract-plugin
export default {"variableIconWrapper":"WhiteLabeling_variableIconWrapper__xZN7y","footerAlign":"WhiteLabeling_footerAlign__nMHMx"};